import SupportCard from "widgets/cards/support";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Support = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex flex-wrap gap-4">
        <SupportCard
          title={t("support.audit.trail")}
          bgColor="50"
          textColor="white"
          onClick={() => navigate(`/admin/support/auditTrail`)}
          permissionRole="administrator"
        />
        <SupportCard
          title={t("support.uvs")}
          bgColor="100"
          textColor="white"
          onClick={() => navigate(`/admin/support/uvs`)}
          permissionRole="super"
        />
        <SupportCard
          title={t("support.bulk.upload")}
          bgColor="200"
          textColor="white"
          onClick={() => navigate(`/admin/support/bulkUpload`)}
          permissionRole="super"
        />
        <SupportCard
          title={t("support.accounts")}
          bgColor="300"
          textColor="white"
          onClick={() => navigate(`/admin/support/accountManagement`)}
          permissionRole="super"
        />
        <SupportCard
          title={t("support.audit.tools")}
          bgColor="400"
          textColor="white"
          onClick={() => navigate(`/admin/support/audit`)}
          permissionRole="super"
        />
        <SupportCard
          title={t("support.hvac.report")}
          bgColor="500"
          textColor="white"
          onClick={() => navigate(`/admin/support/hvacReport`)}
          permissionRole="super"
        />
      </div>
    </div>
  );
};

export default Support;
